/**
 * One date format for the whole admin panel: "07 Oct 2026" (and a 12-hour
 * time). The month is spelled out so a date can't be read either way —
 * 07/10/2026 was being read as July 10.
 *
 * A bare `toLocaleDateString()` / `toLocaleString()` follows the browser's
 * own locale, so on an en-US browser dates came out as mm/dd/yyyy. These
 * always use en-IN, in India time (same as the log pages' own formatters).
 * Every function returns '—' for an empty or invalid value.
 */

const LOCALE = 'en-IN';
const TIME_ZONE = 'Asia/Kolkata';

function toDate(value) {
    if (value === null || value === undefined || value === '') return null;
    const d = value instanceof Date ? value : new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
}

/** 08 Oct 2026 */
export function formatDate(value) {
    const d = toDate(value);
    if (!d) return '—';
    return d.toLocaleDateString(LOCALE, { timeZone: TIME_ZONE, day: '2-digit', month: 'short', year: 'numeric' });
}

/** 08 Oct 2026, 12:00 pm */
export function formatDateTime(value) {
    const d = toDate(value);
    if (!d) return '—';
    return d.toLocaleString(LOCALE, {
        timeZone: TIME_ZONE, day: '2-digit', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit', hour12: true,
    });
}

/** 12:00:05 pm */
export function formatTime(value) {
    const d = toDate(value);
    if (!d) return '—';
    return d.toLocaleTimeString(LOCALE, { timeZone: TIME_ZONE, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });
}

const pad = (n) => String(n).padStart(2, '0');

/**
 * 'YYYY-MM-DD' for a date input, in the browser's own time zone — the format
 * <input type="date"> / DateInput use. (`toISOString().split('T')[0]` is the
 * UTC date, which is yesterday's date in India before 05:30.)
 */
export function toInputDate(value = new Date()) {
    const d = toDate(value);
    if (!d) return '';
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** 'YYYY-MM-DDTHH:mm' for a datetime input, in the browser's own time zone. */
export function toInputDateTime(value = new Date()) {
    const d = toDate(value);
    if (!d) return '';
    return `${toInputDate(d)}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
